const QUERY_REQUEST_TYPES = ['TEMPORARY_TRAFFIC_REGULATION', 'TEMPORARY_TRAFFIC_REGULATION_EXCAVATION']
export default {
  methods: {
    goBack () {
      const { from } = this.$route?.query || {}
      const { parent_vue_name: parentViewName } = this.$route?.meta || {}
      const backComponentUiViewName = from || parentViewName

      if (backComponentUiViewName) {
        this.$router.push({
          name: backComponentUiViewName
        }).then()
      }
    },

    /*
    set investors blocks visibility by request type and regulation setter values
    LEGEND:
      * - traffic regulation investor
      ** - repair investor
      *** - add oib and address to contractor block
      (+) - visible
      (-) - invisible

    1) request type = PRP
      1.1) regulation setter = Zagrebačke ceste
        - *(+)
        - **(-)
      1.2) regulation setter = Izvođač
        - *(-)
        - **(-)
        - ***(+)
    2) request type = PRP + Prijekop
      2.1) regulation setter = Zagrebačke ceste
        - *(+)
        - **(+)
      2.2) regulation setter = Izvođač
        - *(-)
        - **(+)
        - ***(+)
   */
    manageInvestorsVisibilityByRequestTypeAndRegulationSetter (regulationSetter, requestType) {
      const { name } = regulationSetter || {}

      const result = {
        trafficRegulationInvestor: false,
        repairInvestor: false,
        contractorAddress: false,
        contractorOib: false
      }

      // guard clause
      if (!QUERY_REQUEST_TYPES.includes(requestType)) {
        return result
      }

      // request type rule (ONLY difference)
      const repairInvestor = requestType === 'TEMPORARY_TRAFFIC_REGULATION_EXCAVATION'

      // regulation setter rules
      const visibilityBySetter = {
        ZG_ROADS: {
          trafficRegulationInvestor: true,
          contractorAddress: false,
          contractorOib: false
        },
        CONTRACTOR: {
          trafficRegulationInvestor: false,
          contractorAddress: true,
          contractorOib: true
        }
      }

      const config = visibilityBySetter?.[name]

      // apply updates
      this.$set(this.cardsVisibility, 'trafficRegulationInvestor', !!config?.trafficRegulationInvestor)
      this.$set(this.cardsVisibility, 'repairInvestor', repairInvestor)

      this.$set(this.fieldsVisibilityConfig.contractorAddress, 'visible', !!config?.contractorAddress)
      this.$set(this.fieldsVisibilityConfig.contractorOib, 'visible', !!config?.contractorOib)

      result.trafficRegulationInvestor = !!config?.trafficRegulationInvestor
      result.repairInvestor = repairInvestor
      result.contractorAddress = !!config?.contractorAddress
      result.contractorOib = !!config?.contractorOib

      return result
    }
  }
}
